module.exports = __webpack_public_path__ + "img/dexguru.0674595f.png";